const isMobileDevice = () => {
  const regexAndroid = /Android/i;
  const regexIOS = /iPhone|iPad|iPod/i;
  const regexWindowsPhone = /Windows Phone/i;
  const isSmallScreen = window.innerWidth <= 720;

  if (
    navigator.userAgent.match(regexAndroid) ||
    navigator.userAgent.match(regexIOS) ||
    navigator.userAgent.match(regexWindowsPhone) ||
    (window.Cypress && process.env.NODE_ENV === 'test')
  ) {
    return isSmallScreen;
  }
  return false;
};

export default isMobileDevice;
